<template>
  <div class="filterTags__tagsGroup">
    <fieldset class="filterTags__tagsGroupWrapper">
      <legend class="filterTags__tagsGroupTitle">{{ filter.title }}</legend>
      <ul id="filterTags__tagsTagWrapper" class="filterTags__tagsTagWrapper" data-tag-wrapper>
        <template v-for="facet in filter.facets" :key="facet.id">
          <li v-if="checkFacetTitle(facet.label)" class="filterTags__tagsTagItem">
            <input
              :id="facet.id"
              :key="facet.id"
              class="isSrOnly"
              type="checkbox"
              :value="facet.title"
              :name="facet.title"
              :checked="facet.selected"
              :disabled="facet.disabled"
              @change="
                filterProducts(facet.urlToApiWithParams, facet.urlToShow);
                likecountert();
                prepareTagging($event, filter, facet);
              "
            />
            <label
              class="filterTags__tag"
              :class="{ '-selected': facet.selected, '-disabled': facet.disabled }"
              :for="facet.id"
            >
              {{ facet.label }}
              <span v-if="!facet.disabled" class="filterTags__facetCount">({{ facet.count }})</span>
            </label>
          </li>
        </template>
      </ul>
    </fieldset>
  </div>
</template>

<script>
import { tag } from '../../../../../Foundation/Core/code/Scripts/analyticsHandler/directives/tag';

let TAGGING_FILTERS = [];

export default {
  name: 'FilterTags',
  directives: {
    tag,
  },
  props: {
    filter: { type: Object, required: true },
  },
  data() {
    return {
      allitemsArticle: [],
      filterValue: '',
      category: window.wsf.AnalyticsVariables.pageCategory
        ? window.wsf.AnalyticsVariables.pageCategory
        : 'content page',
    };
  },
  /* istanbul ignore next */
  methods: {
    filterProducts(apiUrl, pushState = false) {
      this.$parent.filterProducts(apiUrl, pushState);
    },

    removeActiveClasses() {
      const activeArticles = document.querySelectorAll('.active_like');
      activeArticles.forEach((article) => {
        article.classList.remove('active_like');
      });
    },

    collectArticleIds() {
      const allArticles = document.querySelectorAll('.like__btn');
      allArticles.forEach((article) => {
        this.allitemsArticle.push(article.getAttribute('id'));
      });
    },

    applyStoredLikes(articlelike) {
      articlelike.forEach((likedId) => {
        const element = document.getElementById(likedId);
        if (element) {
          element.classList.add('active_like');
        }
      });
    },

    collectFilterValues() {
      const selectedFilterTags = document.querySelectorAll('.-selected');
      const filterValues = [];
      selectedFilterTags.forEach((item) => filterValues.push(item.control.name));
      this.filterValue = filterValues.join('::');
    },

    updateLikeCounts(jsonData) {
      const hideableSections = document.querySelectorAll('.like__btn');
      hideableSections.forEach((section, i) => {
        const allarticleIds = section.getAttribute('id');
        const likeCount = jsonData.list[i].likeCount;
        const likeNumberElement = document
          .getElementById(allarticleIds)
          .getElementsByClassName('like__number')[0];
        likeNumberElement.innerHTML = likeCount > 0 ? likeCount : '';
      });
    },

    likecountert() {
      setTimeout(() => {
        this.removeActiveClasses();
        this.collectArticleIds();

        const articlelike = JSON.parse(localStorage.getItem('articlelike'));
        if (articlelike && articlelike.length > 0) {
          this.applyStoredLikes(articlelike);
        }

        this.collectFilterValues();

        fetch(`/api/sitecore/article/GetLikeCountList?&idList=${this.allitemsArticle}`)
          .then((response) => response.json())
          .then((jsonData) => this.updateLikeCounts(jsonData))
          .catch((e) => console.error(e));
      }, 2599);
    },
    prepareTagging(event, filter, facet) {
      const filterAlreadyExists = TAGGING_FILTERS.filter(
        (filter) => filter.value === facet.title.toLowerCase()
      ).length;

      if (filterAlreadyExists) {
        // remove it from the list
        TAGGING_FILTERS.splice(
          TAGGING_FILTERS.findIndex(({ value }) => value === facet.title.toLowerCase()),
          1
        );
      } else {
        if (event.target.checked) {
          TAGGING_FILTERS.push({
            category: filter.title.toLowerCase(),
            value: facet.title.toLowerCase(),
          });
        }
      }

      const GROUPED_TAGGING_FILTERS = TAGGING_FILTERS.reduce((group, { category, value }) => {
        group[category] = group[category] ?? [];
        group[category].push(value);
        return group;
      }, []);

      const labelFromTaggingFilters = Object.keys(GROUPED_TAGGING_FILTERS).map((key) => {
        return `${key}::${GROUPED_TAGGING_FILTERS[key].join('::')}`;
      });

      this.$emit('on-tag-change', {
        tagging: {
          category: this.category,
          action: 'filter::by needs',
          label: `${filter.title}::${facet.title}`,
          filter_type: 'filter',
          filter_value: labelFromTaggingFilters.join('::'),
          event_name: 'use_filters',
        },
      });
    },
    checkFacetTitle(facetTitle) {
      const uuidRegexp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      const isUUID = uuidRegexp.test(facetTitle);

      return !isUUID;
    },
  },
};
</script>
